import React from 'react'
import { Statistic, Progress } from 'semantic-ui-react'
import { connect } from 'react-redux'


const yellow = '#ffe445'



class Timer extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            startTime: 0,
            remainingTime: 0,
            intervalId: 0,
        }
    }

    componentDidMount() {
        this.setState({intervalId: setInterval(this.tick, 100) })
    }

    componentWillUnmount() {
        const { intervalId } = this.state
        if (intervalId)
            clearInterval(intervalId)
    }

    tick = () => { 
        const { ms, onTimerFinished  } = this.props
        const {startTime} = this.state;
        const elapsedTime = Date.now() - this.state.startTime
        const remainingTime = ms - elapsedTime
        if (this.props.isReady){
            if (startTime == 0) this.setState({startTime: Date.now()})
            else{
                    if (this.props.isRunning){
                    if (remainingTime > 0) {
                        this.setState({ remainingTime })
                    } else {
                        onTimerFinished();
                        clearInterval(this.state.intervalId)
                        this.setState({ remainingTime: 0 })
                        this.props.handleAnswer(Math.ceil(remainingTime / 1000));
                    }
                }else{
                    clearInterval(this.state.intervalId)
                    this.setState({ remainingTime:remainingTime})
                    this.props.handleAnswer(Math.ceil(remainingTime / 1000));            
                }
            }
        }
    }
    render() {
        const { ms, bar,isRunning } = this.props
        const { remainingTime } = this.state

        return (
            bar ?
                <Progress total={ms} value={remainingTime} attached='bottom' color='purple' /> :
                <Statistic>
                    <Statistic.Value><span style={{ color: yellow }}>{isRunning?((this.state.remainingTime / 1000).toFixed(0)):Math.ceil(this.state.remainingTime / 1000)}</span> </Statistic.Value>
                    <Statistic.Label>Secondi</Statistic.Label>
                </Statistic>    
        )
    }
}

const mapStateToProps = (state, {}) => ({
})

const mapDispatchToProps = (dispatch, { socket }) => ({
})

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(Timer)




// WEBPACK FOOTER //
// ./src/components/Timer.js